import React, { FC } from 'react'
import styled from 'styled-components'
import { EBreakpoint, EColor, EFontFamily } from 'src/styles/type'
import Text from './Texts/Text'
import Svg from './Svg'

/**
 * Style
 */

const MainContainer = styled(({ ...props }) => <div {...props} />)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ $size }) => ($size === 'big' ? '2.3rem' : '0rem')};

  @media (max-width: ${EBreakpoint.MOBILE}) {
    position: relative;
    right: 5rem;
  }

  .text {
    position: absolute;
    margin-left: ${({ $size }) => ($size === 'big' ? '-2rem' : '-2.2rem')};
    margin-top: ${({ $size }) => ($size === 'big' ? '0rem' : '-2.2rem')};
    color: white;
    font-weight: 700;
  }
  .arrow {
    position: absolute;
    margin-left: -2.3rem;
    margin-top: ${({ $size }) => ($size === 'big' ? '1rem' : '-1rem')};
  }
`

const Bubble = styled(({ ...props }) => <div {...props} />)`
  width: 270px;
  height: 270px;
  border-radius: 70% 42% 56% 53% / 72% 47% 62% 41%;
  background-color: ${({ $background }) => $background};

  ${({ $size }) =>
    $size === 'small' &&
    `
    padding-top: 4rem;
    `}
`

const NumberComponent = styled(({ ...props }) => <span {...props} />)`
  padding-left: 0.5rem;
  font-family: ${EFontFamily.POPPINS};
  font-size: ${({ $size }) => ($size === 'big' ? '8rem' : '5rem')};
  font-weight: 700;
  color: ${({ $textColor }) => $textColor};

  & > sup {
    font-size: ${({ $size }) => ($size === 'big' ? '3rem' : '2rem')};
    vertical-align: top;
    top: ${({ $size }) => ($size === 'big' ? '1.7rem' : '0.5rem')};
    position: relative;
  }
  & > sub {
    position: relative;
    right: ${({ $size }) => ($size === 'big' ? '2.7rem' : '1.8rem')};
    font-size: ${({ $size }) => ($size === 'big' ? '1.5rem' : '1rem')};
    font-family: ${EFontFamily.ROBOTO};
    font-weight: 500;
  }
`

const Amount = styled(({ ...props }) => <span {...props} />)``

/**
 * Component
 */
const BubbleWithArrow: FC<{
  amount: number
  symbol?: string
  textColor?: EColor
  background?: EColor
}> = ({
  amount,
  symbol = '€',
  background = EColor.INTERMEDIATE_BLUE,
  textColor = EColor.WHITE,
}) => {
  const size = amount.toString().length < 3 ? 'big' : 'small'

  return (
    <MainContainer>
      <Bubble $background={background} $size={size}>
        <Svg
          className="arrow"
          src={`components/arrow/curve-arrow`}
          color={EColor.WHITE}
          width="60px"
        />
        <Text>A partir de</Text>
        <NumberComponent
          $amount={amount}
          background={background}
          $textColor={textColor}
          $size={size}
        >
          {symbol && symbol === '$' && <sup>{symbol}</sup>}
          <Amount>{amount}</Amount>
          {symbol && symbol !== '$' && <sup>{symbol}</sup>}
          {symbol === '$' ? <sub>/month</sub> : <sub>/mois</sub>}
        </NumberComponent>
      </Bubble>
    </MainContainer>
  )
}

export default BubbleWithArrow
